import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { PaymentFooterModule } from '@arc/unified-payments-frontend/payment-footer';
import { SharedPaymentModule } from '@arc/unified-payments-frontend/shared-payment';
import {
  I18nModule,
  LazyModuleLanguageChangeEffects,
} from '@arc/unified-payments-frontend/i18n';
import { PayOnAccountCoreComponent } from './components/pay-on-account-core/pay-on-account-core.component';
import { PayOnAccountCoreComponentEffects } from './components/pay-on-account-core/store';
import { PayOnAccountStoreModule } from './store/pay-on-account.store.module';

@NgModule({
  declarations: [PayOnAccountCoreComponent],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    SharedPaymentModule,
    PaymentFooterModule,
    PayOnAccountStoreModule,
    EffectsModule.forFeature([
      LazyModuleLanguageChangeEffects,
      PayOnAccountCoreComponentEffects,
    ]),
  ],
  exports: [RouterModule, PaymentFooterModule, SharedPaymentModule, I18nModule],
})
export class PayOnAccountCoreModule {}
